import { Injectable } from "@angular/core";

import { map, Observable } from "rxjs";

import { ApiResponse } from "@app/lib/types";

import { BaseApiService } from "@app/shared/services";
import {
  VendorDocumentUploadDto,
  VendorDocumentUploadResponseDto,
  VendorOrderCreatedDto,
} from "@features/orders/models";

@Injectable({
  providedIn: "root",
})
export class VendorOrderApiService extends BaseApiService {
  protected readonly endpoint = "/vendororder";
  protected readonly microservice = "orderEntry" as const;

  /**
   * POST /api/vendororder/order/{orderId}
   */
  createVendorOrder(orderId: number): Observable<VendorOrderCreatedDto> {
    return this.post<VendorOrderCreatedDto, null>(null, `/order/${orderId}`);
  }

  /**
   * POST /api/vendororder/vendor-documents/manual-upload
   */
  uploadVendorDocument(
    request: VendorDocumentUploadDto,
  ): Observable<VendorDocumentUploadResponseDto> {
    const formData = new FormData();

    formData.append("File", request.file, request.file.name);
    formData.append("OrderId", request.orderId.toString());

    if(request.vendorOrderCompletedDate) {
      formData.append("VendorOrderCompletedDate", request.vendorOrderCompletedDate);
    }
    if(request.clientOrderCompletedDate) {
      formData.append("ClientOrderCompletedDate", request.clientOrderCompletedDate);
    }

    const url = `${this.apiUrl}/vendor-documents/manual-upload`;

    return this.http
      .post<ApiResponse<VendorDocumentUploadResponseDto>>(url, formData)
      .pipe(
        map((response: ApiResponse<VendorDocumentUploadResponseDto>) => {
          if (!response.success) {
            throw new Error(
              response.errors?.[0] ??
                response.message ??
                "Failed to process vendor upload doc",
            );
          }
          return response.data as VendorDocumentUploadResponseDto;
        }),
      );
  }
}
